/* eslint-disable import/no-cycle */
import React from 'react';
import {useTranslation} from 'react-i18next';
import {observer} from 'mobx-react-lite';
import Section from './Section';
import InspectionTaskDetails from '../InspectionTaskDetails';

const ResultsDescription = ({task}) => {
  const {t} = useTranslation();

  return (
    <Section title={t('inspectionTask.drilldownModal.section.results')}>
      <InspectionTaskDetails task={task}/>
    </Section>
  );
};

export default observer(ResultsDescription);
